<template>
  <div         
    :class="'reveal-image'">
    <div v-if="!isPassed" class="reveal-image__waypoint" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"></div>
    <slot></slot>
  </div>
</template>

<script>

import { styler, tween } from 'popmotion'

export default {
  name: 'RevealBlock',
  data: () => ({
    intersectionOptions: {
      threshold: 0.25
    },
    isPassed: false
  }),
  methods: {
    onWaypoint ({ going }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.isPassed = true
      }
    }
  },
  watch: {
    isPassed (passed) {
      if (!passed) return
      const revealImg = styler(this.$el)
      tween({ to: 1, duration: 1000 }).start(
        {
          update: (v) => revealImg.set('opacity', v)
        }
      )
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>
